import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom';

import { Layout } from './Layout';
import { ErrorBoundary } from './components';

import { enabledPage } from ':constants';

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<Layout />} errorElement={<ErrorBoundary />}>
      {enabledPage.map(({ path, ...route }) => (
        <Route
          key={path}
          path={path}
          errorElement={<ErrorBoundary />}
          {...route}
        />
      ))}
    </Route>,
  ),
);
